module.exports = __webpack_public_path__ + "assets/images/totop.png?bf17c5bd27d546c42b4c1c084b975af2";